/**
 * Fix CSS3 100vh not constant in mobile browser - see: https://stackoverflow.com/a/56986938/794071 
 */
let vh = window.innerHeight * 0.01;

document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// init map as callback on Google Maps JavaScript include (see functions.php)
function initMap() {
  // area map (tilted Google Satellite)
  // https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/aerial-simple
  if ($('.google-map').length > 0) {
    $('.google-map').each(function(index, value) {
      var map;
      map = new google.maps.Map(this, {
        center: {lat: 51.9066999, lng: 4.4752611}, //calandstraat 25
        zoom: 18, //minimum of 18 is required for titled 3D satellite view
        disableDefaultUI: true,
        mapTypeId: 'satellite',
        gestureHandling: 'cooperative',
        scrollwheel: false,
      });
      map.setTilt(45); //tilt map to the only available tilt (45deg)

      var markers = window.area_map.markers;
      var marker, i, infowindow = new google.maps.InfoWindow( { pixelOffset: new google.maps.Size(0, -10) } );
  
      // loop through all the markers in window.area_map.markers
      for (i = 0; i < markers.length; i++) { 
          // add a marker 
          marker = new google.maps.Marker({
              position: new google.maps.LatLng(markers[i]['latlng']['lat'], markers[i]['latlng']['lng']),
              map: map,
              icon: window.area_map.icon,
              // title: markers[i]['iw_text'] // disabled by design
          });
          
          // Add event listener to marker with reference to marker inforwindow content
          if (!!markers[i]['information_window']) {
            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    if (!!markers[i]['iw_image']) {
                      infowindow.setContent(markers[i]['iw_image'] + markers[i]['iw_text']);
                    } else {
                      infowindow.setContent(markers[i]['iw_text']);
                    }
                    infowindow.open(map, marker);
                }
            })(marker, i));
          }

          // Open infowindow for first marker with marker infowindow content
          if (i == 0 && !!markers[i]['information_window']) {
            infowindow.setContent(markers[i]['iw_image'] + markers[i]['iw_text']);
            infowindow.open(map, marker);
          }
      }
    });
  }
}

jQuery( document ).ready(function( $ ) {
  // Handler for .ready() called.

  // Featherlight lightbox
  $('[data-featherlight-trigger]').on('click', function() {
    var $target = $('[data-target=' + $(this).data('featherlight-trigger') + ']');

    $.featherlightGallery($target, {previousIcon: '', nextIcon: '', afterOpen: function() {
      //do stuff, e.g. force autoplay
    }});
  });

  // autoplay videos in video page section (pagepiling section autoplay is done on pagepiling callback)
  function playVideo($player) {
    var playPromise = $player.get(0).play();
  
    if (playPromise !== undefined) {
      playPromise.then(function() {
        $player.addClass('playing');
      }).catch(function(error) {
        $player.removeClass('playing');
      });
    } else {
      if ($player.get(0).currentTime > 0 && !$player.get(0).paused && !$player.get(0).ended) {
        $player.removeClass('playing'); 
      } else {
        $player.addClass('playing');
      }
    }
  }

  var $videos = $('.section--video video');
  $(document).on('scroll.video, click.video', function() {
    $(document).off('scroll.video, click.video');
    $videos.each(function() {
      playVideo($(this));
    });
  });

  // pagepiling script has been customised to meet client demands (animation)
  if ($('#pagepiling').length) {
    $('#pagepiling').pagepiling({
      verticalCentered: false,
      navigation: {},
      anchors: $('#pagepiling .section').map(function(index, section) {
        var $section = $(section);
        return !!$section.data('anchor') ? $section.data('anchor') : 'page-' + (index + 1);
      }),
      afterLoad: function(anchorLink, index){
        // play videos
        var $section = $('#pagepiling').find('.section').eq(index - 1);
        if ( $section.hasClass('pp-type-video') ) {
          var $video = $section.find('video');
          $video.get(0).play();
        }

      },
      onLeave: function(index, nextIndex, direction) {
        // hide logo on scrollable slides
        if ($('.pp-section').last().hasClass('pp-scrollable')) {
          var total = $('.pp-section').length;
          if (nextIndex === total) {
            setTimeout(function() {
              $('.navbar-brand').addClass('pp-hidden');
          }, 400);
          } else {
            setTimeout(function() {
              $('.navbar-brand').removeClass('pp-hidden');
            }, 400);
          }
        }
      },
      afterRender: function(){
        setTimeout(function() {
          $('#pagepiling').css('opacity', 1);
        }, 500);
      },
    });

    $('.js--pagepile-next').on('click', function() {
      $.fn.pagepiling.moveSectionDown();
    });
  }

  /** Hamburger menu overlay */
  var $menu_animating = false;
  $('.hamburger').on('click', function(event) {
    event.preventDefault();
    var $self = $(this);
    if ($menu_animating) {return;}
    $menu_animating = true;
    if ($self.hasClass('open')) {
      $self.removeClass('open');
      $('body').addClass('js--menu-closing');
      setTimeout(function() {
        $self.removeClass('click');
        $('body').removeClass('js--menu-open');
        $('body').removeClass('js--menu-closing');
      }, 400);
    } else {
      $self.addClass('click');
      $('body').addClass('js--menu-opening');
      $('body').addClass('js--menu-open');
      setTimeout(function() {
        $self.addClass('open');
        $('body').removeClass('js--menu-opening');
      }, 400);
    }
    $menu_animating = false;
    return false;
  });

  /** Gallery sliders (slick) */
  if ($('.js--slick-gallery').length) {
    $('.js--slick-gallery').each(function(index) {
      var $slick = $(this);
      var $nav = $slick.parent().find('.gallery__nav');
      var $status = $nav.find('.nav__status');

      // set status/slidecount through listener
      $slick.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
      });

      // init slider
      $slick.slick({
        'infinite': true,
        'fade': false,
        'appendArrows': $nav,
        'adaptiveHeight': true,
      });

    });
  };
});  